import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
// import '@fortawesome/fontawesome-free/css/all.min.css';
// import 'bootstrap-css-only/css/bootstrap.min.css';
// import 'mdbreact/dist/css/mdb.css';
// import { MDBInput } from 'mdb-react-ui-kit';
import { store } from "../../redux/store";
import { selectedRechargableAmnt, selectedRechargableAmnt1, setBrowsePlans, setCurrenntCircle, setCurrentOpertaor, setRechargeTxhHistory, setRechargeType, setRechrgeMobile, setShowRecargeSection } from "../../redux/recharge/recharge.action";
import { Link } from "react-router-dom";

import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import tokenErrorHandler from "../tokenErrorHandler";
const httpClient = axios.create();
class MobileRecharge extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message: '',
            planTypeList: [],
            selectedPlan: '',
            amount: '',
            mobileErrMsg: '',
            amountErrMsg: '',
            operatorErrMsg: '',
            mobile: ''
        }
    }
    enterMobileNumber = (e) => {
        e.preventDefault();

        this.setState({
            mobile: e.target.value
        })
        if (e.target.value.length == 10) {
            this.setState({
                mobileErrMsg: ''
            })
            this.getOperatorDetaislByNo(e.target.value);
        }
    }

    selectAirtel = () => {

        store.dispatch(setCurrentOpertaor('AIRTEL'))
        this.setState({
            operatorErrMsg: ''
        })
    }
    selectBSNL = () => {
        store.dispatch(setCurrentOpertaor('BSNL'))
        this.setState({
            operatorErrMsg: ''
        })
    }
    selectJIO = () => {
        store.dispatch(setCurrentOpertaor('JIO'))
        this.setState({
            operatorErrMsg: ''
        })
    }
    selectVodafone = () => {
        store.dispatch(setCurrentOpertaor('VODAFONE'))
        this.setState({
            operatorErrMsg: ''
        })
    }

    setSelectedAmount = (value) => {

    }
    enterAmount = (e) => {
        e.preventDefault();

        this.setState({
            amountErrMsg: '',
            amount: e.target.value
        })
    }

    changeAmount = (e) => {
        e.preventDefault();
        this.setState({
            amountErrMsg: '',
            amount: this.props.rechargeAmount
        })
        store.dispatch(selectedRechargableAmnt(''))
    }
    showBrowsePlanDivision = () => {
        this.getPlanByoperator();
        store.dispatch(setShowRecargeSection('plans'));
    }

    getPlanByoperator() {
        store.dispatch(setBrowsePlans('loading'));
        var getPlanByoperatorUrl = '/api/v1/catalog/mobile/get-plan';
        var headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        var header = {
            msgType: "GET_ALL_PRODUCT_GROUPS",
            service: "MOBILE",
            channel: "ADMIN",
            requesterId: this.props.clientRequesterId,
            requestId: uuidv4(),//filled by the 3rd party requester
            time: moment().utc(),
            traceId: uuidv4(),
        }

        var request = {
            header: header,
            mobile: this.props.rechargeMobileNo,
            operator: this.props.selectedOperator,
            circle: (this.props.selectedCircle == null || this.props.selectedCircle == '') ?
                'ALL' : this.props.selectedCircle
        }

        httpClient.post(getPlanByoperatorUrl, request, {
            timeout: 60 * 1000,
            timeoutErrorMessage: 'timeout',
            headers
        }
        ).then((response) => {
            console.log("response...." + JSON.stringify(response.data));
            if (response.data.response.success == true) {

                var planData = {
                    circlrBasedPlanHeaders: [],
                    circlrBasedPlans: '',
                    selectedPlan: '',
                    planList: '',
                    operator: ''
                }


                if (response.data.plans != '') {
                    var planMapList = new Map(Object.entries(response.data.plans));

                    var circliList = [...planMapList.keys()]
                    var circlrBasedPlanList = [];
                    var circleList = [];
                    if (circliList.length > 0) {
                        circliList.map(circle => {
                            var circlrBasedPlans = new Map(Object.entries(planMapList.get(circle)));
                            circlrBasedPlanList.push(circlrBasedPlans);
                            circleList.push(circle);

                            var circlrBasedPlanHeaders = [...circlrBasedPlans.keys()];
                            var firstHeader = circlrBasedPlanHeaders[0];
                            var planList = circlrBasedPlans.get(firstHeader);

                            planData = {
                                circlrBasedPlanHeaders: circlrBasedPlanHeaders,
                                circlrBasedPlans: circlrBasedPlans,
                                selectedPlan: firstHeader,
                                planList: planList,
                                operator: this.props.selectedOperator
                            }
                            console.log(JSON.stringify(planData));
                            store.dispatch(setBrowsePlans(planData));

                        })
                    }

                } else {
                    store.dispatch(setBrowsePlans('error'));
                }

            } else {
                store.dispatch(setBrowsePlans('error'));
            }
        }).catch(error => {

            store.dispatch(setBrowsePlans('error'));
            // if (error.message.includes("401")) {
            //     tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            // } else {

            // }
        })
    }
    proceedtoRecarge = () => {
        var amount = '';


        this.setState({
            amountErrMsg: '',
            displayErrorMsg: '',
            mobileErrMsg: ''
        })
        if (this.props.rechargeAmount != '') {
            amount = this.props.rechargeAmount;
        } else if (this.state.amount != '') {
            amount = this.state.amount;
        }

        if (amount != '' && this.state.mobile != '' && this.state.mobile.length == 10
            && this.props.selectedOperator != '') {
            store.dispatch(selectedRechargableAmnt1(amount));
            store.dispatch(setRechargeType('mobile'));
            store.dispatch(setRechrgeMobile(this.state.mobile));
            setTimeout(() => {
                var rechargeMoneyTransfer = document.getElementById('rechargeMoneyTransfer');
                rechargeMoneyTransfer.click();
            }, 1000);

        } else {


            if (amount == '') {
                this.errorMessageCall('Please enter an amount to proceed', 'amount')
            }
            if (this.state.mobile == '' || this.state.mobile.length < 10) {

                store.dispatch(setCurrentOpertaor(''));
                store.dispatch(setCurrenntCircle(''));
                store.dispatch(setRechrgeMobile(''));

                this.errorMessageCall('Please enter valid Mobile No', 'mobile')
            }
            if (this.props.selectedOperator == '') {
                this.errorMessageCall('Please select valid operator', 'operator')
            }

        }


    }
    componentDidMount() {
        this.setState({
            displayErrorMsg: '',
            amountErrMsg: '',
            mobileErrMsg: ''
        })
        store.dispatch(setCurrentOpertaor(''));
        store.dispatch(setCurrenntCircle(''));
        store.dispatch(setRechrgeMobile(''));
        store.dispatch(selectedRechargableAmnt(''));
        store.dispatch(setBrowsePlans(''));
        store.dispatch(setRechargeTxhHistory(''));
        this.loadTxnHistory();

    }
    componentWillUnmount() {
    }

    loadTxnHistory() {
        store.dispatch(setRechargeTxhHistory('loading'));
        var url = '';
        url = '/api/v1/proxy/mobile/order/history';

        var d = new Date();
        d.setDate(d.getDate() - 2);
        var startDate = d.toISOString().slice(0, 10);
        var d1 = new Date();
        d1.setDate(d1.getDate() + 1);
        var endDate = d1.toISOString().slice(0, 10);
        console.log('to date..' + endDate);
        console.log('start date' + startDate);


        var header = {
            msgType: "ORDER_HISTORY",
            // service: this.props.rechargeType == 'mobile' ? 'MOBILE' :
            //     this.props.rechargeType == 'dth' && 'DTH',
            service: 'MOBILE',
            src: "recharge",
            dst: "recharge",
            channel: "API",
            requesterId: this.props.clientRequesterId,
            requestId: uuidv4(),
            traceId: uuidv4(),
        }
        var request = {
            header: header,
            device: this.props.deviceInfo,
            agentId: this.props.agentInfo.id,
            pageNo: 0,
            startDate: startDate,
            endDate: endDate

        }

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        console.log('txn history req:' + JSON.stringify(request));

        httpClient.post(url, request, {
            timeout: 60 * 1000,
            timeoutErrorMessage: 'timeout',
            headers
        }
        ).then((response) => {

            console.log(' response' + JSON.stringify(response.data));
            if (response.data.response.msg == 'SUCCESS') {
                store.dispatch(setRechargeType('mobile'));
                store.dispatch(setRechargeTxhHistory(response.data.orders));
            } else {
                store.dispatch(setRechargeTxhHistory('error'));
            }
        }).catch(error => {

            store.dispatch(setRechargeTxhHistory('error'));
            // if (error.message.includes("401")) {
            //     tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            // } else {

            // }
        })
    }



    getOperatorDetaislByNo(mobileNo) {
        this.setState({
            displayErrorMsg: '',
            operatorErrMsg: ''
        })
        store.dispatch(setCurrentOpertaor(''));
        store.dispatch(setCurrenntCircle(''));
        store.dispatch(setRechrgeMobile(''));
        var getOperatorDetaislByNoUrl = '/api/v1/catalog/mobile/operator/' + mobileNo;
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        httpClient.get(getOperatorDetaislByNoUrl, {
            timeout: 60 * 1000,
            timeoutErrorMessage: 'timeout',
            headers
        }
        ).then((response) => {
            console.log("response...." + JSON.stringify(response.data));

            if (response.data.response.success == true) {
                store.dispatch(setCurrentOpertaor(response.data.operator));
                store.dispatch(setCurrenntCircle(response.data.circle));
                store.dispatch(setRechrgeMobile(response.data.mobile));

            }


        }).catch(error => {


            this.errorMessageCall('Something went wrong,please try later!', 'operator');
            // if (error.message.includes("401")) {
            //     tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            // } else {

            // }
        })
    }


    errorMessageCall = (message, type) => {
        if (type == 'amount') {
            this.setState({
                amountErrMsg: message
            })
        }
        if (type == 'mobile') {
            this.setState({
                mobileErrMsg: message
            })
        }
        if (type == 'operator') {
            this.setState({
                operatorErrMsg: message
            })
        }
    }


    render() {

        return (

            <div class="rechargebox" id="mobileform">
                <Link to='/recharge-money-transfer'>
                    <button id='rechargeMoneyTransfer' hidden={true}></button>
                </Link>
                <div class="form-floating mb-3 mt-3">
                    <input type="number" id="mdn" class="form-control" maxlength="10"
                        onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
                        onChange={this.enterMobileNumber} required
                        placeholder="Enter mobile" name="mobile">
                    </input>
                    <label for="mdn">Mobile</label>
                    <div class='valid-error'>
                        {this.state.mobileErrMsg}
                    </div>

                </div>


                <div class="operator">
                    <label>Operator</label>
                    <ul>
                        <li class={this.props.selectedOperator == 'AIRTEL' && this.state.mobile.length == 10 && 'active'} ><img src="images/airtel.png" alt="Airtel" data-toggle="tooltip" title="Airtel" onClick={this.selectAirtel} /></li>
                        <li class={this.props.selectedOperator == 'BSNL' && this.state.mobile.length == 10 && 'active'}><img src="images/bsnl.png" alt="BSNL" data-toggle="tooltip" title="BSNL" onClick={this.selectBSNL} /></li>
                        <li class={this.props.selectedOperator == 'JIO' && this.state.mobile.length == 10 && 'active'}><img src="images/jio2.png" alt="Jio" data-toggle="tooltip" title="Jio" onClick={this.selectJIO} /></li>
                        <li class={this.props.selectedOperator == 'VODAFONE' && this.state.mobile.length == 10 && 'active'}><img src="images/vi.png" alt="Vi" data-toggle="tooltip" title="Vodafone Idea" onClick={this.selectVodafone} /></li>
                    </ul>
                    <div class='valid-error'>
                        {this.state.operatorErrMsg}

                    </div>
                </div>

                <div class="form-floating mb-3 mt-3">

                    {this.props.rechargeAmount != '' ?
                        <input type="number" id="amt" class="form-control amntxt" maxlength="5"
                            onInput={(e) => e.target.value = e.target.value.slice(0, 5)}
                            onChange={this.changeAmount} required
                            value={this.props.rechargeAmount}
                            placeholder="Enter amount" name="amount"
                        ></input> :
                        <input type="number" id="amt" class="form-control amntxt" maxlength="5"
                            onInput={(e) => e.target.value = e.target.value.slice(0, 5)}
                            onChange={this.enterAmount} required
                            value={this.state.amount}
                            placeholder="Enter amount" name="amount"
                        ></input>

                    }

                    <label for="amt">Amount</label>
                    {this.props.selectedOperator != undefined &&
                        this.props.selectedOperator != '' &&
                        this.props.selectedOperator != null &&
                        this.state.mobile != null &&
                        this.state.mobile != undefined &&
                        this.state.mobile != '' &&
                        this.state.mobile.length == 10 &&
                        <div>
                            <div class="pbtn">
                                <button type="button" id="dthplans" onClick={this.showBrowsePlanDivision}>Browse Plans</button></div>

                        </div>
                    }
                    {this.props.rechargeAmount == '' && this.state.amount == '' &&
                        <div class='valid-error'>
                            {this.state.amountErrMsg}
                        </div>
                    }
                </div>
                <button type="button" class="btn btn-primary" id="mobilecharge"
                    onClick={this.proceedtoRecarge}>Proceed</button>


            </div>




        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        miscReduce: { phone, token, clientRole, agentInfo, clientRequesterId, callBackUrl },
        rechargeReduce: { selectedOperator, rechargeAmount, rechargeMobileNo } }
) => ({
    errorMessage, loginErrorMessage, phone, token, clientRole, agentInfo, clientRequesterId,
    callBackUrl,
    selectedOperator, rechargeAmount, rechargeMobileNo
});

export default connect(mapStateToProps, null)(MobileRecharge);
